import React, { useContext, useState } from 'react';
import { Row, Col, Input, Button } from "antd";
import { CloseSquareFilled, CarryOutFilled, StopFilled } from '@ant-design/icons';
import { AppContext } from '../../../util/context';
import { updateHazard, updateHazardActions } from '../../../graphql/mutations';

export const CardOverview = ({
    handleSaveClick,
    setLoading,
    hazardCard,
    setError,
    setSaveSuccess,
    client,
    closeCard, 
    getCurrentDate
}) => {
    const {
        StyledDiv
    } = useContext(AppContext)

    const [showVoidDetails, setShowVoidDetails] = useState(false);
    const [closeValidation, setCloseValidation] = useState("");
    const [submitValidation, setSubmitValidation] = useState("");
    const [justificationDetails, setJustificationDetails] = useState("");
    const [maxChar, setMaxChar] = useState("0");

    const handleSubmitClick = () => {
        if(justificationDetails === "") {
            setSubmitValidation("Justification is required");
        }else{
            setLoading(true);
            voidCard()
        }
    }

    async function voidCard() {
        try{
            const updatedHazardCard = {
                id: hazardCard.id,
                status: "void",
                justification: justificationDetails,
                observationCategory: hazardCard.observationCategory,
                _version: hazardCard._version
            }

            await client.graphql({
                query: updateHazard,
                variables: { input: updatedHazardCard }
            })

            if(hazardCard.actions.length > 0 ){
                const updatedActions = hazardCard.actions.map(async (actionData) => {
                    let action = {
                        id: actionData.id,
                        status: "void",
                        _version: actionData._version
                    }

                    return client.graphql({
                        query: updateHazardActions,
                        variables: { input: action }
                    })

                })

                await Promise.all(updatedActions)
            }

            setSaveSuccess({show: true, message: "Card Voided", type: "cardVoid"})
        }catch(error){
            setError({show: true, message: "Error Voiding Card"})
        }finally{
            setLoading(false);
        }
    }

    const handleCloseClick = () => {
        if(hazardCard.observationCategory === null){
            setCloseValidation("Observation category is required");
        }else{
            setCloseValidation("");
            setLoading(true);
            closeCardData()
        }
    }

    async function closeCardData(){
        
        try{
            const updatedHazardCard = {
                id: hazardCard.id,
                status: "closed",
                closeDate: getCurrentDate(),
                observationCategory: hazardCard.observationCategory,
                _version: hazardCard._version
            }

            await client.graphql({
                query: updateHazard,
                variables: { input: updatedHazardCard }
            })

            setSaveSuccess({show: true, message: "Card Closed", type: "cardClosed"})
        }catch(error){
            console.log(error)
            setError({show: true, message: "Error Closing Card"})
        }finally{
            setLoading(false)
        }
    }

    return (
        <>

            {/*<Row
                style={{
                    height: "10%",
                    justifyContent: "center",
                    fontSize: "20px",
                    fontWeight: "500",
                    alignItems: "center"
                }}
            >
                <StyledDiv>{hazardCard.HZDID.toUpperCase()}</StyledDiv>
            </Row>*/}

            {(hazardCard.status === "closed" || hazardCard.status === 'void') && <Row
                style={{
                    height: "90%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <StyledDiv className={hazardCard.status === 'closed' ? "overviewStatusClosed" : "overviewStatusVoid"}>{hazardCard.status.toUpperCase()}</StyledDiv>
            </Row>}

            {hazardCard.status !== "closed" && hazardCard.status !== 'void' && <Row
                style={{
                    height: "90%",
                }}
            >
                {closeCard && <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    className={showVoidDetails ? "hideOverviewContainer" : "overviewContainer"}
                >
                    <div
                        className="overviewCloseContainer"
                        onClick={() => {
                            handleCloseClick()
                        }}
                    >
                        <CloseSquareFilled className="overviewCloseIcon"/>
                        <StyledDiv className="overviewCloseText">Close Card</StyledDiv>
                    </div>
                    {closeValidation !== "" && <>
                        <StyledDiv className="inputTextLabel" style={{marginTop: "12px", fontSize: "12px"}}>
                            <span style={{color: "red"}}>{closeValidation}</span>
                        </StyledDiv>
                    </>}
                </Col>}

                <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    className={"overviewContainer"}
                >
                    <div
                        className="overviewVoidContainer"
                        onClick={() => {
                            setShowVoidDetails(!showVoidDetails);
                        }}
                    >
                        <StopFilled className="overviewVoidIcon"/>
                        <StyledDiv className="overviewVoidText">Void Card</StyledDiv>
                    </div>
                </Col>

                <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    className={showVoidDetails ? "hideOverviewContainer" : "overviewContainer"}
                >
                    <div
                        className="overviewSaveContainer"
                        onClick={() => {handleSaveClick()}}
                    >
                        <CarryOutFilled className="overviewSaveIcon"/>
                        <StyledDiv className="overviewSaveText">Save Changes</StyledDiv>
                    </div>
                </Col>

                <Col
                    xl={{span: 16}}
                    lg={{span: 16}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    className={showVoidDetails ? "" : "hideOverviewContainer"}
                >
                    <Row
                        gutter={[0, 16]}
                    >
                        <Col
                            span={24}
                        >
                            {showVoidDetails && <label>     
                                <StyledDiv className="inputTextLabel">
                                    <span style={{color: "red"}}>*</span> Justification
                                    <div className="homeInfoContainer">
                                        <Input.TextArea
                                            placeholder="Enter Jusication (max length 300 characters)"
                                            style={{
                                                resize: "none",
                                                height: "100px",
                                                marginTop: "8px"
                                            }}
                                            value={justificationDetails}
                                            onChange={(e) => {
                                                setJustificationDetails(e.target.value);
                                                setMaxChar(e.target.value.length);

                                                if(submitValidation !== "") 
                                                    setSubmitValidation("");
                                            }}
                                            maxLength={300}
                                            className={submitValidation !== "" ? "inputText homeValidationInputText" : "inputText"}
                                        />
                                        {submitValidation && 
                                            <span className="homeValidationMessage">{submitValidation}</span>
                                        }
                                        <span className="maxCharMessage">{maxChar}/300</span>
                                    </div>
                                </StyledDiv>
                            </label>}

                            
                        </Col>

                        <Col
                            span={24}
                            style={{
                                display: "flex",
                                justifyContent: "start"
                            }}
                        >
                           {showVoidDetails && <Button onClick={() => {handleSubmitClick()}}>Submit</Button>}
                        </Col>
                    </Row>
                </Col>
            </Row>}
        </>
    )
}
